import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { InputMain } from "components";
import {
  bankAccountActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnSuccessActions,
} from "store";
import {
  FindError,
  FindLoad,
  FindSuccess,
  ProfileInfo,
  SaveParams,
} from "utils";
import { Stepper } from "./stepper";

const ACTION_TYPE = "CONNECT_BANK_ACCOUNT";

export const ConnectBankAccount = () => {
  const location = useLocation();
  const navigator = useNavigate();
  const info = location?.state;
  const { handleSubmit, control, reset, clearErrors } = useForm();
  const dispatch = useDispatch();
  const { myProfile } = ProfileInfo();
  const connectLoading = FindLoad(ACTION_TYPE);
  const connectError = FindError(ACTION_TYPE);
  const connectSuccess = FindSuccess(ACTION_TYPE);

  useEffect(() => {
    if (info?.bankAccount) {
      reset(info?.bankAccount);
    }
  }, [info]);

  useEffect(() => {
    if (connectSuccess?.type) {
      const params = {
        ...info,
        step: 7,
      };

      SaveParams(location?.pathname, navigator, params);
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
    }
  }, [connectSuccess]);

  useEffect(() => {
    return () => {
      clearErrors();
      dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    };
  }, []);

  const handleCreate = (data) => {
    const params = {
      ...info,
    };

    dispatch(
      bankAccountActions.connectBankAccount(data, myProfile?.pmtAccount?._id)
    );

    params.bankAccount = {
      ...data,
    };
    SaveParams(location?.pathname, navigator, params);
  };

  return (
    <form className="in-memory-of-box" onSubmit={handleSubmit(handleCreate)}>
      <div className="in-memory-of-content">
        <div className="container">
          <div className="in-memory-form-wrapper ConnectBankAccount-wrapper">
            <div className="in-memory-form-header">
              <p className="in-memory-form-header-title">
                Connect Your Bank Account
              </p>
            </div>

            <div className="in-memory-form-content">
              <InputMain
                className="celebration-input"
                name="accountNumber"
                type="number"
                control={control}
                placeholder="Enter your bank account number"
                labelHeader="Bank Account Number"
                rules={{
                  required: "Bank account number is required",
                  minLength: {
                    value: 8,
                    message:
                      "Bank Account Number must be minimum 8 characters long",
                  },
                  maxLength: {
                    value: 17,
                    message:
                      "SSN last 4 numbers must be maximum 17 characters long",
                  },
                }}
              />

              <InputMain
                className="celebration-input"
                name="routingNumber"
                control={control}
                type="number"
                placeholder="Provide your bank's routing number"
                labelHeader="Routing Number"
                rules={{
                  required: "Routing number is required",
                  minLength: {
                    value: 9,
                    message: "Routing number must be 9 characters long",
                  },
                  maxLength: {
                    value: 9,
                    message: "Routing number must be 9 characters long",
                  },
                }}
              />

              <p className="error-message">{connectError?.error}</p>
            </div>
          </div>
        </div>
      </div>
      <Stepper loading={connectLoading} />
    </form>
  );
};
